export default __webpack_public_path__ + "static/2020-4-317d4b1984ea062200b2e4babdd7ff61.jpg";